<template>
  <div
    :class="{
      'logo-image-holder': !collapsed,
      'hyp-logo-link': !this.disableToggle,
    }"
  >
    <v-img
      @click="toggle()"
      :src="src"
      contain
      alt="hyperion logo"
      class="hyp-logo"
      ><span v-if="deployEnvStage" class="hyp-logo-test"
        >{{ deployEnvStage }} ENV</span
      ></v-img
    >
  </div>
</template>

<script>
import { DEPLOY_ENV } from "@/common/config";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "LogoGrd",
  props: {
    width: {
      type: Number,
      default: 39,
    },
    height: {
      type: Number,
      default: 39,
    },
    disableToggle: {
      type: Boolean,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    src() {
      return require(`@/assets/images/hiscox_cr_logo.jpg`);
    },
    deployEnvStage() {
      if (
        DEPLOY_ENV.toLowerCase() === "test" ||
        DEPLOY_ENV.toLowerCase() === "development"
      ) {
        return DEPLOY_ENV.length > 4
          ? DEPLOY_ENV.toUpperCase().substring(0, 3)
          : DEPLOY_ENV.toUpperCase();
      }
      return false;
    },
  },
  methods: {
    toggle() {
      if (!this.disableToggle) {
        this.$emit(EMITTED_ACTIONS.CLICK);
      }
    },
  },
};
</script>

<style scoped>
.logo-image-holder {
  padding-top: 20px;
  padding-bottom: 10px;
  background-color: white;
}
.hyp-logo {
  margin: auto;
}
.hyp-logo-link .hyp-logo {
  cursor: pointer;
}
.hyp-logo-test {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #bf2500;
  margin-top: -5px;
}
</style>
